// File: src/components/home/PopularBrands.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useCity } from "../../context/CityContext";
import "../../styles/home/PopularBrands.css";

const PopularBrands = () => {
  const navigate = useNavigate();
  const { selectedCity } = useCity();

  const brands = [
    { name: "Maruti Suzuki", count: 1250, logo: "/carbrand/maruti.png" },
    { name: "Hyundai",       count: 980,  logo: "/carbrand/hyundai.png" },
    { name: "Honda",         count: 750,  logo: "/carbrand/honda.png" },
    { name: "Tata Motors",   count: 650,  logo: "/carbrand/tata.png" },
    { name: "Mahindra",      count: 550,  logo: "/carbrand/mahindra.png" },
    { name: "Toyota",        count: 480,  logo: "/carbrand/toyota.png" },
    { name: "Kia",           count: 420,  logo: "/carbrand/kia.png" },
    { name: "Volkswagen",    count: 380,  logo: "/carbrand/vw.png" },
  ];

  const handleBrandClick = (brand) => {
    const params = new URLSearchParams();
    params.set("brand", brand.name);
    if (selectedCity && selectedCity !== "All Cities") {
      params.set("location", selectedCity);
    }
    navigate(`/buy-cars?${params.toString()}`);
  };

  return (
    <section className="popular-brands-section">
      <div className="pb-bg-orb pb-orb-1" />
      <div className="pb-bg-orb pb-orb-2" />

      <div className="pb-container">
        <div className="pb-header">
          <span className="pb-eyebrow">✦ Top Manufacturers</span>
          <h2 className="pb-title">Browse by Brand</h2>
          <p className="pb-subtitle">
            Explore India's most trusted car brands — all verified listings, one platform.
          </p>
        </div>

        <div className="brands-grid">
          {brands.map((brand, index) => (
            <div
              key={index}
              className="brand-card"
              onClick={() => handleBrandClick(brand)}
              style={{ "--delay": `${index * 60}ms` }}
            >
              <div className="brand-card-glow" />
              <div className="brand-logo-wrap">
                <div className="brand-logo">
                  <img src={brand.logo} alt={brand.name} />
                </div>
              </div>
              <h4 className="brand-name">{brand.name}</h4>
              {/*<span className="brand-count">{brand.count.toLocaleString()}+ cars</span>*/}
              <div className="brand-cta">
                Explore <span className="brand-arrow">→</span>
              </div>
            </div>
          ))}
        </div>

        <div className="pb-footer">
          <div className="pb-footer-line" />
          <span className="pb-footer-text"></span>
          <div className="pb-footer-line" />
        </div>
      </div>
    </section>
  );
};

export default PopularBrands;